import { Box } from "@mui/material";
import DocumentsAccordion from "../../DocumentsAccordion";

export default function DocumentsTab({ projectData }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <DocumentsAccordion projectData={projectData} />
    </Box>
  );
}
